<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]">
    <!-- 导航栏 -->
    <navBar>
      <div slot="title" class="flex-2 text-center">{{ $t("products.navTitle") }}（{{ cartItems.length }}）</div>
    </navBar>

    <div class="pt-2">
      <!-- 购物车商品列表 -->
      <div v-if="cartItems.length > 0">
        <!-- 全选 -->
        <div class="flex items-center p-3 bg-white mb-2 mx-4 rounded-lg">
          <van-icon :name="isAllSelected ? 'checked' : 'circle'" color="#ff7a00" size="20" @click="toggleSelectAll" />
          <span class="ml-2 text-base">{{ $t("products.selectAll") }}</span>

          <div class="items-center hidden md:flex text-base">
            <span>（{{ cartItems.length }}）</span>
          </div>
        </div>
        <div v-for="item in cartItems" :key="item.sku" class="flex items-center py-3 px-3 bg-white mb-2 mx-4 rounded-lg">
          <van-swipe-cell class="w-full">
            <div class="flex items-center">
              <!-- 勾选图标 -->
              <van-icon
                :name="selectedIds.includes(item.id) ? 'checked' : 'circle'"
                color="#ff7a00"
                size="20"
                @click.stop="toggleItemSelect(item)" />
              <img :src="item.picUrl" class="w-16 h-16 rounded-lg flex-shrink-0 mr-2 ml-2" />

              <!-- 商品信息 -->
              <div class="flex-1">
                <h3 class="text-base font-medium mb-1">{{ isZh ? item.region : item.regionEn }}</h3>
                <div class="text-sm text-gray-500 mb-2">
                  {{
                    isZh
                      ? item.selectedText + (item.day > 1 ? $t("products.days") : $t("products.day"))
                      : item.selectedTextEn + (item.day > 1 ? $t("products.days") : $t("products.day"))
                  }}
                </div>

                <!-- 价格和数量 -->
                <div class="flex items-center justify-between">
                  <div class="flex items-center flex-row">
                    <span class="text-xs text-gray-400 line-through">RM{{ formatToYuan(item.marketPrice) }}</span>
                    <span class="ml-1 text-base font-bold text-[#ff7a00]">RM {{ formatToYuan(item.price) }}</span>
                  </div>

                  <!-- 数量控制 -->
                  <div class="flex items-center">
                    <div class="flex items-center border border-gray-200 rounded px-2 py-1">
                      <van-icon v-if="item.count === 1" name="delete" size="16" @click="removeItem(item)" />
                      <van-icon v-else name="minus" size="16" color="black" @click="handleDecrease(item)" />
                      <span class="mx-2 text-sm">{{ item.count }}</span>
                      <van-icon name="plus" size="16" color="black" @click="increaseQuantity(item)" />
                    </div>

                    <span class="hidden md:block ml-3 rounded-md text-sm text-gray-900" @click="removeItem(item)">
                      {{ $t("address.delete") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <template #right class="">
              <div class="flex items-center justify-center h-full">
                <van-button square type="danger" :text="$t('address.delete')" class="h-full" @click="removeItem(item)" />
              </div>
            </template>
          </van-swipe-cell>
        </div>
      </div>

      <!-- 空购物车状态 -->
      <div v-else class="flex flex-col items-center justify-center mt-20">
        <van-empty :description="$t('products.cardEmpty')" />
      </div>
    </div>

    <!-- 优惠信息 -->
    <div v-if="cartItems.length > 0" class="mx-4 mt-4">
      <div class="bg-white rounded-lg p-3 px-2">
        <div class="space-y-2 text-sm">
          <div class="flex items-center">
            <span>{{ $t("products.cardDesc1") }}</span>
            <!-- <span class="text-[#ff7a00] font-medium">&nbsp;{{ $t("products.cardDesc4") }}</span> -->
          </div>
          <div class="flex items-center">
            <span>{{ $t("products.cardDesc2") }}</span>
          </div>
          <!-- 立即注册 -->
          <div class="flex items-center" v-if="!isLoggedIn">
            <span class="text-[#ff7a00]">{{ $t("products.cardDesc3") }}{{ newReward }}{{ $t("products.cardDesc8") }}</span>
            <van-button type="primary" size="mini" plain class="ml-2 w-20" color="#ff7a00" @click="handleLogin">
              {{ $t("products.cardBtnText1") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-26"></div>
    <!-- 底部结算栏 -->
    <div v-if="cartItems.length > 0" :class="[' fixed bottom-0 left-0 right-0  yoyo-container mx-auto h-19 ', ,]">
      <div class="flex h-full z-50 items-center pr-2 w-full lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-2">
        <!-- 有选中商品时显示金额信息 -->
        <div v-if="selectedIds.length > 0" class="flex-1 text-right mr-4 flex flex-col justify-between">
          <div class="text-base font-bold text-[#ff7a00]">RM {{ formatToYuan(selectedTotalAmount) }}</div>
          <div class="text-sm text-gray-500">
            {{ $t("products.cardDesc5") }}&nbsp;{{ selectedTotalGivePoint.point }} {{ $t("products.cardDesc6") }}，{{ $t("products.cardDesc7")
            }}{{ selectedTotalGivePoint.pointPrice }}
          </div>
        </div>
        <!-- 没有选中商品时占位 -->
        <div v-else class="flex-1"></div>

        <!-- 结算按钮 -->
        <van-button type="primary" class="rounded-xl w-20 h-10" color="#ff7a00" :disabled="totalCount === 0" @click="checkout">
          {{ $t("products.cardBtnText2") }}
        </van-button>
      </div>
    </div>

    <!-- <van-tabbar
      v-if="$route.query.showTabbar"
      route
      :class="['z-999 transition-transform duration-300 flex md:hidden', { 'translate-y-full': !showTabbar }]">
      <van-tabbar-item :to="item.to" v-for="item in tabbarItems" :key="item.name">
        <template #icon>
          <img :src="item.icon" class="w-14 h-14" />
        </template>
      </van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
import { Tabbar, TabbarItem, SwipeCell, Toast } from "vant"
import { mapGetters, mapMutations } from "vuex"
import { formatToYuan } from "@/utils/common"
import { getCartList, cartUpdate, cartDel, getNewReward } from "@/apis/shop"
export default {
  name: "ShoppingCart",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [SwipeCell.name]: SwipeCell,
  },
  data() {
    return {
      backSrc: require("@/assets/images/back.png"),
      cartItems: [],
      activeTab: 0,
      formatToYuan,
      // 滚动相关状态
      showTabbar: true,
      lastScrollTop: 0,
      // 滚动阈值：适当增大，避免轻微抖动就频繁触发隐藏/显示
      scrollThreshold: 8,
      // 是否处于底部锁定区（靠近底部时强制显示 tabbar，避免来回抖动）
      bottomLock: false,
      givePoint: 0,
      givePointPrice: 0,
      newReward: 0,
      // 选择状态
      selectedIds: [], // 选中的商品ID数组
    }
  },
  computed: {
    totalCount() {
      return this.cartItems.reduce((total, item) => total + item.count, 0)
    },
    // 是否全选
    isAllSelected() {
      return this.cartItems.length > 0 && this.selectedIds.length === this.cartItems.length
    },
    // 选中的商品列表
    selectedItems() {
      return this.cartItems.filter((item) => this.selectedIds.includes(item.id))
    },
    // 选中商品的总金额
    selectedTotalAmount() {
      return this.selectedItems.reduce((total, item) => total + item.price * item.count, 0)
    },
    
    selectedTotalGivePoint() {
      let obj = {
        point: 0,
        pointPrice: 0
      }
      if (this.isLoggedIn) {
        obj = {
          point: this.givePoint,
          pointPrice: this.givePointPrice
        }
      } else {
        obj = {
          point: formatToYuan(this.selectedTotalAmount, 0),
          pointPrice: formatToYuan(formatToYuan(this.selectedTotalAmount))
        }
      }
      return obj
    },

    tabbarItems() {
      return this.isZh
        ? [
            { name: "home", icon: require("@/assets/images/tabbar/home.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            {
              name: "cart",
              icon: require("@/assets/images/tabbar/cart-active.png"),
              to: { name: "cart", query: { showTabbar: true } },
              w: 8,
            },
            { name: "mine", icon: require("@/assets/images/tabbar/my.png"), to: { name: "mine" }, w: 10 },
          ]
        : [
            { name: "home", icon: require("@/assets/images/tabbar/home-en.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo-en.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            {
              name: "cart",
              icon: require("@/assets/images/tabbar/cart-en-active.png"),
              to: { name: "cart", query: { showTabbar: true } },
              w: 8,
            },
            { name: "mine", icon: require("@/assets/images/tabbar/my-en.png"), to: { name: "mine" }, w: 10 },
          ]
    },
    totalAmount() {
      return this.cartItems.reduce((total, item) => total + item.price * item.count, 0)
    },
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf("micromessenger") !== -1
    },
  },
  watch: {
    selectedIds(newValue) {
      if (this.isLoggedIn) {
        this.givePoint = 0
        this.givePointPrice = 0
        this.fetchCartList()
      }
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.fetchCartList()
    } else {
      this.loadCartData()
    }
  },
  methods: {
    ...mapMutations({
      setRegisterDialogVisible: "auth/SET_REGISTER_DIALOG_VISIBLE",
    }),
    loadCartData() {
      // 从localStorage加载购物车数据
      const cartData = localStorage.getItem("yoyotravel_cart")
      if (cartData) {
        this.cartItems = JSON.parse(cartData)
        console.log("localStorage cartItems :>> ", this.cartItems)
      }
      getNewReward()
        .then((res) => {
          this.newReward = res.data
        })
        .catch((err) => {
          console.log("getCouponList error :>> ", err)
        })
    },
    fetchCartList() {
      getCartList({ ids: this.selectedIds.length ? this.selectedIds : '' })
        .then((res) => {
          const newData = []
          const list = res.data.list
          list.forEach((item) => {
            const { sku, spu } = item
            newData.push({
              sku: sku.id,
              region: `${spu.type} ${this.isZh ? spu.place : spu.placeEn}`,
              regionEn: `${spu.type} ${this.isZh ? spu.place : spu.placeEn}`,
              selectedText: `${this.isZh ? sku.packageName : sku.packageNameEn} ${this.isZh ? sku.dayName : sku.dayNameEn}`,
              selectedTextEn: `${this.isZh ? sku.packageNameEn : sku.packageNameEn} ${this.isZh ? sku.dayNameEn : sku.dayNameEn}`,
              count: item.count,
              price: sku.price,
              marketPrice: sku.marketPrice,
              type: spu.type,
              picUrl: process.env.VUE_APP_IMAGE_URL + spu.picUrl,
              id: item.id,
              day: item.sku.dayName
            })
          })
          this.cartItems = newData
          this.givePoint = res.data.givePoint
          this.givePointPrice = res.data.givePointPrice
        })
        .catch((err) => {
          console.log("获取购物车列表失败:", err)
        })
    },
    saveCartData() {
      // 保存购物车数据到localStorage
      localStorage.setItem("yoyotravel_cart", JSON.stringify(this.cartItems))
    },
    // 增加数量
    increaseQuantity(item) {
      if (this.isLoggedIn) {
        cartUpdate({
          id: item.id,
          count: item.count + 1,
        })
          .then((res) => {
            this.fetchCartList()
          })
          .catch((err) => {})
      } else {
        item.count++
        this.saveCartData()
      }
    },
    handleDecrease(item) {
      if (this.isLoggedIn) {
        cartUpdate({
          id: item.id,
          count: item.count - 1,
        })
          .then((res) => {
            this.fetchCartList()
          })
          .catch((err) => {})
      } else {
        if (item.count === 1) {
          // 数量为1时，删除商品
          this.removeItem(item.sku)
        } else {
          // 数量大于1时，减少数量
          item.count--
          this.saveCartData()
        }
      }
    },
    removeItem(item) {
      if (this.isLoggedIn) {
        cartDel({
          ids: [item.id],
        })
          .then((res) => {
            this.fetchCartList()
          })
          .catch((err) => {})
      } else {
        this.cartItems = this.cartItems.filter((i) => i.sku !== item.sku)
        this.saveCartData()
      }
    },
    goShopping() {
      this.$router.push("/")
    },
    checkout() {
      if (this.totalCount === 0) {
        Toast("购物车为空")
        return
      }

      // 检查是否有选中的商品
      if (this.selectedIds.length === 0) {
        Toast(this.$t("products.pleaseSelectProducts"))
        return
      }

      localStorage.setItem("yoyotravel_settleData", JSON.stringify(this.selectedItems))

      // 结算逻辑
      this.$router.push("/pay-new")
    },
    // 全选/取消全选
    toggleSelectAll() {
      if (this.isAllSelected) {
        // 取消全选
        this.selectedIds = []
        
      } else {
        // 全选
        this.selectedIds = this.cartItems.map((item) => item.id)
      }
    },
    // 切换单个商品选中状态
    toggleItemSelect(item) {
      const index = this.selectedIds.indexOf(item.id)
      if (index > -1) {
        // 已选中，取消选中
        this.selectedIds.splice(index, 1)
      } else {
        // 未选中，添加到选中列表
        this.selectedIds.push(item.id)
      }
    },
    // 处理滚动事件 - 结合两者优点的混合逻辑
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // 1. 立即更新 HomeHeader 的滚动进度（实时响应，无防抖）
      this.updateHeaderScrollProgress(scrollTop)

      // 2. 立即更新 Tabbar 显示逻辑（实时响应，无防抖）
      this.updateTabbarVisibility(scrollTop, windowHeight, documentHeight)
    },

    // HomeHeader 滚动进度更新（防抖动优化版本）
    updateHeaderScrollProgress(scrollTop) {
      // 1. 计算scrollTop变化量
      const scrollDiff = Math.abs(scrollTop - this.lastHeaderScrollTop)

      // 2. 设置阈值：只有滚动距离超过3px才更新
      const scrollThreshold = 3

      // console.log(
      //   "🎯 [滚动检测] scrollTop:",
      //   scrollTop.toFixed(2),
      //   "上次:",
      //   this.lastHeaderScrollTop.toFixed(2),
      //   "差值:",
      //   scrollDiff.toFixed(2),
      //   "px",
      // )

      // 3. 如果变化量小于阈值，直接跳过
      if (scrollDiff < scrollThreshold) {
        // console.log("⏸️ [跳过更新] 变化太小 (<", scrollThreshold, "px)")
        return
      }

      // 4. 计算新的进度值
      const rawProgress = Math.min(scrollTop / this.maxScrollForHeaderAnimation, 1)

      // 5. 四舍五入到小数点后2位，进一步减少微小变化
      const roundedProgress = Math.round(rawProgress * 100) / 100

      // 6. 检查进度是否真的变化了
      if (Math.abs(roundedProgress - this.scrollProgress) < 0.01) {
        // console.log("⏸️ [跳过更新] 进度值未变化，当前:", this.scrollProgress)
        // 即使进度没变，也更新lastHeaderScrollTop，避免累积效应
        this.lastHeaderScrollTop = scrollTop
        return
      }

      // 7. 更新进度和记录位置
      // console.log("✅ [更新进度]", this.scrollProgress.toFixed(3), "→", roundedProgress.toFixed(3), "| scrollTop:", scrollTop.toFixed(2))
      this.scrollProgress = roundedProgress
      this.lastHeaderScrollTop = scrollTop
    },

    // Tabbar 显示逻辑（来自 Home.vue 的简单逻辑）
    updateTabbarVisibility(scrollTop, windowHeight, documentHeight) {
      // 顶部保护：在接近页面顶部（含 iOS 回弹的轻微负/正偏移）时，始终显示 tabbar
      const topBuffer = 2
      if (scrollTop <= topBuffer) {
        this.showTabbar = true
        this.lastScrollTop = 0
        return
      }

      // 底部缓冲区，略大于 tabbar 高度，避免因为 tabbar 显隐导致 documentHeight 轻微变化，反复触发切换
      const bottomBuffer = 60 // 进入底部区域的缓冲
      const enterThreshold = documentHeight - bottomBuffer
      const leaveThreshold = documentHeight - bottomBuffer * 2 // 离开底部区域需要再往上滚一段，形成“锁定区”

      const currentBottom = scrollTop + windowHeight

      // 1）靠近底部：进入锁定区，强制显示 tabbar
      if (currentBottom >= enterThreshold) {
        this.showTabbar = true
        this.bottomLock = true
        this.lastScrollTop = scrollTop
        return
      }

      // 2）已经在底部锁定区，但还没真正离开太远：继续保持 tabbar 显示，避免来回抖动
      if (this.bottomLock && currentBottom > leaveThreshold) {
        this.showTabbar = true
        this.lastScrollTop = scrollTop
        return
      }

      // 3）离开底部锁定区足够远，解除锁定
      if (this.bottomLock && currentBottom <= leaveThreshold) {
        this.bottomLock = false
      }

      // 4）正常滚动逻辑：根据滚动方向显示/隐藏
      const scrollDirection = scrollTop > this.lastScrollTop ? "down" : "up"

      // 只有滚动距离超过阈值才触发显示/隐藏
      if (Math.abs(scrollTop - this.lastScrollTop) > this.scrollThreshold) {
        if (scrollDirection === "down") {
          // 向下滚动，隐藏tabbar
          this.showTabbar = false
        } else {
          // 向上滚动，显示tabbar
          this.showTabbar = true
        }
        this.lastScrollTop = scrollTop
      }
    },
    handleLogin() {
      if (!this.isLoggedIn) {
        this.setRegisterDialogVisible(true)
      }
    },
  },
  created() {
    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    // console.log("this.$route.params :>> ", this.$route)
  },
}
</script>

<style scoped>
.cart-page {
}

/deep/.van-tabbar-item__icon img {
  height: auto;
}
</style>
